<template>
  <v-expand-transition>
    <div v-show="modelValue">
      <slot name="expandable">
        <v-card class="pa-5">
          <div class="d-flex justify-space-between mb-5">
            <h4>Email preview</h4>
            <SoButton
              type="icon"
              icon="close"
              @click="() => $emit('update:modelValue', false)"
            />
          </div>
          <p class="mb-5"><strong>Subject: </strong>{{ subject }}</p>
          <p class="text-pre-wrap">
            {{ emailTemplate }}
          </p>
        </v-card>
      </slot>
    </div>
  </v-expand-transition>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoButton,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      subject: {
        type: String,
        default: "",
        required: false,
      },
      emailTemplate: {
        type: String,
        default: "",
        required: false,
      },
    },
    emits: ["update:modelValue"],
  })
</script>
